import { render } from "./AddRole.vue?vue&type=template&id=126a55d4&scoped=true"
import script from "./AddRole.vue?vue&type=script&lang=js"
export * from "./AddRole.vue?vue&type=script&lang=js"

import "./AddRole.vue?vue&type=style&index=0&id=126a55d4&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126a55d4"]])

export default __exports__